import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import React, { useCallback, useState } from "react";
import TextFieldFormControl from "../../field/TextFieldFormControl/TextFieldFormControl";
import AutocompleteField from "../../field/AutocompleteField";
import TrueFalseSelectField from "../../field/TrueFalseSelectField";

const HrQuestionKindForm = React.memo(({ formValue, onChange}) => {
  const { t } = useTranslation();

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      spacing={1}
    >
      <Grid item xs={12}>
          <TextFieldFormControl
            name="hrquestionkind_name"
            label={t("form.hr_question_kind_form.hrquestionkind_name")}
            value={formValue?.hrquestionkind_name}
            onChange={onChange}
            required
          />
      </Grid>

    
        <Grid item xs={12}>
          <TrueFalseSelectField
            name="hrquestion_is_hidden"
            label={t("form.hr_question_kind_form.hrquestion_is_hidden")}
            value={formValue?.hrquestion_is_hidden}
            valuesAsBool
            addEmptyOptions={false}
            onChange={onChange}
            required
          />
        </Grid>
 
    </Grid>
  );
});

HrQuestionKindForm.propTypes = {
  formValue: PropTypes.object,
  filteringData: PropTypes.object,
  onChange: PropTypes.func,
  onChangeAutocomplete: PropTypes.func,
};

export default HrQuestionKindForm;
